export const getRelativeTime = timestamp => {
  const now = new Date().getTime();
  const trimmedNow = Math.round(now / 1000);
  const diff = trimmedNow - timestamp;
  const diff_min = Math.round(diff / 60);
  const diff_h = Math.round(diff_min / 60);
  const diff_d = Math.round(diff_h / 24);
  const diff_y = Math.round(diff_d / 365);
  if (diff < 60) {
    return 'gerade eben';
  } else if (diff_min < 60) {
    return `vor ${diff_min} Min`;
  } else if (diff_h === 1) {
    return 'vor 1 Stunde';
  } else if (diff_h < 24) {
    return `vor ${diff_h} Stunden`;
  } else if (diff_d === 1) {
    return 'vor einem Tag';
  } else if (diff_d < 365) {
    return `vor ${diff_d} Tagen`;
  } else if (diff_y === 1) {
    return 'vor 1 Jahr';
  } else {
    return `vor ${diff_y} Jahren`;
  }
};
